// extracted by mini-css-extract-plugin
export default {"trd":"orderInfo_trd__a9vP9","content":"orderInfo_content__bCwEM","pic-icon":"orderInfo_pic-icon__Sq3UM","pic2":"orderInfo_pic2__GlI6X"};